import React from "react";
import "./index.css";
import PropTypes from "prop-types";

function UserEmpty({ username = "This user" }) {
  return (
    <section className="empty-profile-wrapper">
      <h3 className="-heading-text">{`${username} hasn't added cases`}</h3>
      <p className="-sub-text">When they do, their Cases will show up here.</p>
    </section>
  );
}

UserEmpty.propTypes = {
  username: PropTypes.string,
};

export default UserEmpty;



// WEBPACK FOOTER //
// ./src/scenes/OthersProfile/components/UserEmpty/index.js